import { render, staticRenderFns } from "./VisasListItem.vue?vue&type=template&id=8aa110cc&scoped=true&"
import script from "./VisasListItem.vue?vue&type=script&lang=js&"
export * from "./VisasListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa110cc",
  null
  
)

export default component.exports